document.addEventListener('DOMContentLoaded', function() {
    const megamenu = document.querySelector('.utad-megamenu');
    const body = document.body;
    const backButtonTitle = document.querySelector('.utad-megamenu__back-title');
    const hamburgerButton = document.querySelector('.utad-megamenu__hamburger');
    const backButton = document.querySelector('#megamenuBack');

    // Obtener el breakpoint del atributo data-megamenu-responsive
    const breakpoint = parseInt(megamenu.getAttribute('data-megamenu-responsive')) - 1;

    // Función para verificar si estamos en móvil
    const isMobile = () => window.innerWidth <= breakpoint;

    // Función para resetear el estado cuando cambiamos de móvil a desktop
    const resetState = () => {
        if (!isMobile()) {
            // Limpiar el texto del botón de retroceso
            if (backButtonTitle) {
                backButtonTitle.textContent = '';
            }
            // Remover todas las clases de estado
            document.querySelectorAll('[data-megamenu-level]').forEach(item => {
                item.classList.remove('is-active', 'is-inactive');
            });
            // Resetear el historial y nivel
            if (backButton) {
                titleHistory = [];
                backButton.setAttribute('data-megamenu-back-level', '0');
                backButton.classList.remove('is-active');
            }
        }
    };

    // Array para almacenar el historial de títulos
    let titleHistory = [];

    // Evento de resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            resetState();
        }, 250); // Debounce de 250ms
    });

    // Evento click para el botón hamburger
    hamburgerButton.addEventListener('click', function() {
        if (!isMobile()) return; // Solo ejecutar en móvil

        // Limpiar el texto del botón de retroceso cuando se cierra el menú
        if (this.classList.contains('collapsed')) {
            backButtonTitle.textContent = '';
            // Remover clases al cerrar el menú
            document.querySelectorAll('[data-megamenu-level]').forEach(item => {
                item.classList.remove('is-active', 'is-inactive');
            });
            // Resetear el historial y nivel
            if (backButton) {
                titleHistory = []; // Limpiar el array de historial
                backButton.setAttribute('data-megamenu-back-level', '0');
                backButton.classList.remove('is-active');
            }
        }
    });

    // Evento click para el botón de retroceso
    if (backButton) {
        backButton.addEventListener('click', function() {
            if (!isMobile()) return; // Solo ejecutar en móvil

            const currentLevel = parseInt(this.getAttribute('data-megamenu-back-level'));
            
            // Si estamos en el nivel 1, simplemente limpiar todo y volver al estado inicial
            if (currentLevel === 1) {
                // Remover todas las clases de estado
                document.querySelectorAll('[data-megamenu-level]').forEach(item => {
                    item.classList.remove('is-active', 'is-inactive');
                });
                // Resetear el botón
                this.classList.remove('is-active');
                backButtonTitle.textContent = '';
                this.setAttribute('data-megamenu-back-level', '0');
                titleHistory = []; // Limpiar el array de historial
                return;
            }

            // Para otros niveles, mantener la lógica existente
            if (titleHistory.length > 0) {
                // Obtener el último título del array
                const lastTitle = titleHistory.pop();
                console.log('Historial actual:', titleHistory);
                
                // Actualizar el nivel actual
                const previousLevel = currentLevel - 1;
                this.setAttribute('data-megamenu-back-level', previousLevel || '0');

                // Remover clases del nivel actual
                document.querySelectorAll(`[data-megamenu-level="${currentLevel}"]`).forEach(item => {
                    item.classList.remove('is-active', 'is-inactive');
                });

                // Activar el nivel anterior
                if (previousLevel > 0) {
                    const previousElement = document.querySelector(`[data-megamenu-level="${previousLevel}"]`);
                    if (previousElement) {
                        previousElement.classList.add('is-active');
                        // Si estamos en el último nivel, mostrar el primer título del historial
                        if (previousLevel === 1) {
                            backButtonTitle.textContent = titleHistory[0];
                        } else {
                            backButtonTitle.textContent = lastTitle;
                        }
                        this.classList.add('is-active');
                    }
                }
            }
        });
    }

    // Eventos hover para el megamenu
    if (megamenu) {
        megamenu.addEventListener('mouseenter', function() {
            if (!isMobile()) { // Solo ejecutar en desktop
                body.classList.add('megamenu-active');
            }
        });

        megamenu.addEventListener('mouseleave', function() {
            if (!isMobile()) { // Solo ejecutar en desktop
                body.classList.remove('megamenu-active');
            }
        });

        // Evento click para elementos con data-megamenu-target
        megamenu.addEventListener('click', function(e) {
            if (!isMobile()) return; // Solo ejecutar en móvil

            const targetElement = e.target.closest('[data-megamenu-target]');
            if (targetElement) {
                const title = targetElement.getAttribute('data-megamenu-title');
                console.log('Título del elemento clickeado:', title);
                
                if (backButtonTitle) {
                    backButtonTitle.textContent = title;
                }

                // Obtener el nivel objetivo del elemento clickeado
                const targetLevel = targetElement.getAttribute('data-megamenu-level-target');
                console.log('Nivel objetivo:', targetLevel);
                
                if (targetLevel) {
                    // Actualizar el historial y el nivel actual en el botón de retroceso
                    if (backButton) {
                        const currentLevel = parseInt(backButton.getAttribute('data-megamenu-back-level'));
                        console.log('Nivel actual:', currentLevel);
                        
                        // Añadir el título al historial
                        titleHistory.push(title);
                        console.log('Historial actual:', titleHistory);
                        
                        // Actualizar el nivel actual
                        backButton.setAttribute('data-megamenu-back-level', targetLevel);
                        // Mostrar el botón de back
                        backButton.classList.add('is-active');
                    }

                    // Remover clases de todos los elementos del mismo nivel
                    document.querySelectorAll(`[data-megamenu-level="${targetLevel}"]`).forEach(item => {
                        item.classList.remove('is-active', 'is-inactive');
                    });

                    // Encontrar el elemento padre con el nivel correspondiente
                    const parentElement = targetElement.closest(`[data-megamenu-level="${targetLevel}"]`);
                    if (parentElement) {
                        // Añadir clase al elemento activo
                        parentElement.classList.add('is-active');

                        // Ocultar otros elementos del mismo nivel
                        document.querySelectorAll(`[data-megamenu-level="${targetLevel}"]`).forEach(item => {
                            if (item !== parentElement) {
                                item.classList.add('is-inactive');
                            }
                        });
                    }
                }
            }
        });
    }
});